// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { toggleSettings } from 'store/reducers/uiSettingsSlice';
import useSettingsApi from './useSettingsApi';
import { DataUsageAgreement } from '@tls/sw91-communication/types/com.base';
import { ToastByStatus } from 'components/treactui-template/organisms/toast/ToastMessage';
import { Dialog, FooterButton, Switch } from '@tls/treact-ui';

export function DataAgreementDialog() {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const onClose = useCallback(() => {
    dispatch(toggleSettings());
  }, [dispatch]);
  const open = useAppSelector(s => s.uiSettings.showSettings);

  const { dataUsageAgreement, isLoading, setDataAgreement } = useSettingsApi();
  const [loading, setLoading] = useState(false);
  const onChange = useCallback(async () => {
    setLoading(true);
    const result = await setDataAgreement(
      dataUsageAgreement === DataUsageAgreement.R_AND_D ? DataUsageAgreement.PRIVATE : DataUsageAgreement.R_AND_D
    );
    ToastByStatus(result.status, t('settings.data.title'), t('settings.data.updatedError'));
    setLoading(false);
  }, [dataUsageAgreement, setDataAgreement, t]);

  return (
    <Dialog open={open} onClose={onClose} size={'small'} enableClosing data-testid='settings-data-agreement-dialog'>
      <Dialog.DialogHeader label={t('settings.data.title')} />
      <Dialog.DialogContent>
        <Switch
          label={t('settings.data.details')}
          value={dataUsageAgreement === DataUsageAgreement.R_AND_D}
          disabled={isLoading || loading}
          onChange={onChange}
          data-testid='settings-data-agreement-switch'
        />
      </Dialog.DialogContent>
      <Dialog.Footer
        right={
          <FooterButton
            variant='secondary'
            key='cancel'
            label={t('close')}
            onClick={onClose}
            data-testid='settings-data-agreement-close-button'
          />
        }
      />
    </Dialog>
  );
}
